module.exports = __webpack_public_path__ + "static/media/close-button-ai.7b708e23.svg";